/**
 * Friendly progress labels keyed on the frozen tool names from the kAI v2
 * contract (§6). The drawer shows these while a `tool_call` round is running
 * instead of a bare spinner.
 */
export const TOOL_LABELS = {
  get_order_summary: 'Checking your sales…',
  get_analytics_series: 'Pulling your trends…',
  get_top_items: 'Looking at your top items…',
  get_top_categories: 'Looking at your top categories…',
  get_top_modifiers: 'Looking at your top modifiers…',
  get_payment_summary: 'Reviewing payment methods…',
  get_promo_summary: 'Reviewing your promos…',
  get_busymode_analytics: 'Checking busy mode…',
  resolve_entities: 'Finding your branches…',
};

export const toolLabel = name => TOOL_LABELS[name] || 'Working on it…';
